import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
//import reportWebVitals from './reportWebVitals';
import NavHeader from './navHeader.js';
import NavFooter from './navFooter.js';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(

  <React.StrictMode>
      <NavHeader />
      <App />
      <NavFooter />
  </React.StrictMode>
);




